export const SAFETY_QUESTIONS = {
    energy: [
        { id: 'elektrische_spanning', label: 'Is er risico op elektrische spanning (>50V)?' },
        { id: 'restdruk', label: 'Is er risico op restdruk (Pneumatisch / Hydraulisch)?' },
        { id: 'onverwachte_beweging', label: 'Is er risico op onverwachte beweging (Mechanisch, Zwaartekracht, Veren)?' },
        { id: 'gevaarlijke_temperaturen', label: 'Is er risico op gevaarlijke temperaturen (Heet >50°C of Koud/Cryogeen)?' },
        { id: 'contact_processtoffen', label: 'Is er risico op contact met (gevaarlijke) processtoffen?' },
    ],
    environment: [
        { id: 'werken_op_hoogte', label: 'Wordt er gewerkt op hoogte (>2,5 meter)?' },
        { id: 'besloten_ruimte', label: 'Betreft het werk in een besloten ruimte?' },
        { id: 'moeilijk_bereikbaar', label: 'Is de werkplek moeilijk bereikbaar (krappe ruimte, put, etc.)?' },
        { id: 'atex_zone', label: 'Vinden de werkzaamheden plaats in een ATEX-zone?' },
        { id: 'struikelen_vallen', label: 'Is er risico op struikelen, vallen of stoten (obstakels, gladde vloer)?' },
        { id: 'bewegend_verkeer', label: 'Werkt u in de buurt van bewegend verkeer (heftrucks, vrachtwagens)?' },
    ],
    taskHazards: [
        { id: 'heet_werk', label: 'Wordt er \'heet werk\' uitgevoerd (lassen, slijpen, branden)?' },
        { id: 'handmatig_tillen', label: 'Moet er handmatig getild worden (>25 kg)?' },
        {
            id: 'gehesen',
            label: 'Moet er gehesen worden met een hijsmiddel (takel, kraan)?',
            subQuestions: [
                { id: 'hijsen_routine', label: 'Is het een routineklus (standaard hijsmiddelen, bekend gewicht, geen overzwaai)?' }
            ]
        },
        { id: 'gevaarlijke_chemicalien', label: 'Wordt er gewerkt met (gevaarlijke) chemicaliën (bv. reinigers, smeermiddelen)?' },
        { id: 'lawaai', label: 'Is er risico op blootstelling aan lawaai (>80 dB(A))?' },
        { id: 'stof_rook_dampen', label: 'Is er kans op het vrijkomen van stof, rook of dampen?' },
        { id: 'scherpe_gereedschappen', label: 'Wordt er gewerkt met scherpe of snijdende gereedschappen?' },
    ],
    hygiene: [
        { id: 'glas_hard_plastic', label: 'Is er risico op breuk van glas of hard plastic?' },
        { id: 'open_productielijn', label: 'Werk aan/boven open productielijn?' },
        { id: 'allergenen', label: 'Wordt er gewerkt in een zone met specifieke allergenen?' },
        { id: 'losse_voorwerpen', label: 'Is er kans op losse voorwerpen in het product (moeren, bouten, spanen)?' },
        { id: 'schoonmaken_na_werk', label: 'Moet de werkplek specifiek gereinigd worden na de werkzaamheden?' },
    ]
};
